import React, { ReactNode } from "react"
import { RadioGroup } from "@chakra-ui/react"
import {
  Control, FieldValues, Path, useController,
} from "react-hook-form"
import RadioCardGroup from "components/inputs/RadioCardGroup"

type Props<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
  isAttached?: boolean
  children: ReactNode
}

const RadioCards = <T extends FieldValues>({
  name, control, isAttached, children,
}: Props<T>) => {
  const { field } = useController({ name, control })

  return (
    <RadioGroup value={field.value} onChange={field.onChange}>
      <RadioCardGroup isAttached={isAttached}>{children}</RadioCardGroup>
    </RadioGroup>
  )
}

export default RadioCards
